import { styled } from '@material-ui/core/styles';
import { container } from 'UI/constants/dimensions';

export const ChatContainer = styled('div')({
  flexGrow: 1,
  overflowY: 'auto',
  position: 'relative'
});

export const MessageComposerContainer = styled('div')({
  boxShadow: container.boxShadow,
  position: 'sticky',
  bottom: 0
});
